import React, { useEffect } from "react";

interface DateCellRendererProps {
  value: Date | null | undefined; // Supporta valori null e undefined
}

const DateCellRenderer: React.FC<DateCellRendererProps> = ({ value }) => {
  const formatDate = (dateString: Date) => {
    const date = new Date(dateString);

    // Verifica che la data sia valida
    if (isNaN(date.getTime())) {
      return "-"; // Restituisci "-" per date non valide
    }

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // I mesi partono da 0
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    return `${day}/${month}/${year} ${hours}:${minutes}`;
  };

  if (!value) return <span>-</span>; // Gestione di valori null o undefined

  // Formatta la data
  const formattedDate = formatDate(value);

  return <span>{formattedDate}</span>;
};

export default DateCellRenderer;
